import { useState, useEffect, useCallback } from 'react'
import Wrapper from 'components/reusables/wrapper'
import Templates from './components/templates'
import CertificateTemplatesTabs from './components/certificateTemplatesTabs'

const TemplatesAdministration = () => {
  const [standardSecondaryView, setStandardSecondaryView] = useState(false)
  const [legalSecondaryView, setLegalSecondaryView] = useState(false)
  const inSecondaryView = standardSecondaryView || legalSecondaryView

  const handleStandardSecondaryViewChange = useCallback(
    (isSecondary: boolean) => {
      setStandardSecondaryView(isSecondary)
    },
    []
  )

  const handleLegalSecondaryViewChange = useCallback((isSecondary: boolean) => {
    setLegalSecondaryView(isSecondary)
  }, [])

  /* Respaldo para asociación de cursos, editor de plantillas y formulario DC-3 */
  useEffect(() => {
    const syncSecondaryView = () => {
      setStandardSecondaryView(
        !!document.querySelector('#association-of-courses') ||
          !!document.querySelector('#card .editable')
      )
      setLegalSecondaryView(
        !!document.querySelector(
          '#dc3-attestation-form, #dc3-attestation-associate-courses'
        )
      )
    }

    const observer = new MutationObserver(syncSecondaryView)
    observer.observe(document.body, { childList: true, subtree: true })
    syncSecondaryView()

    return () => observer.disconnect()
  }, [])

  return (
    <Wrapper shadow={true}>
      <CertificateTemplatesTabs
        inSecondaryView={inSecondaryView}
        onLegalSecondaryViewChange={handleLegalSecondaryViewChange}
      >
        <Templates
          inMainView={!inSecondaryView}
          onSecondaryViewChange={handleStandardSecondaryViewChange}
        />
      </CertificateTemplatesTabs>
    </Wrapper>
  )
}

export default TemplatesAdministration
